/* Validation Rules For Login Form */
export function LoginRules() {
  return {
    usernameRules: usernameRules,
    passwordRules: passwordRules,
  };
}

/* Validation Rules For Category Form */
export function CategoryFormRules() {
  return {
    categoryNameRules: nameRules,
    codeRules: codeRules,
    descriptionRules: descriptionRules,
  };
}

export function BrandFormRules() {
  return {
    brandNameRules: nameRules,
    codeRules: codeRules,
    descriptionRules: descriptionRules,
  };
}

export function AccountReceivableFormRules() {
  return {
    issueDateRules: issueDateRules,
    shopRules: shopRules,
    customerIdRules: customerIdRules,
    cashAmountRules: cashAmountRules,
    accountReceivableTypeRules: accountReceivableTypeRules,
    fromDateRules: fromDateRules,
    toDateRules: toDateRules,
    invoiceNoRules: invoiceNoRules,
    remarkRules: remarkRules,
    required: required,
  };
}

export function AccountPayableFormRules() {
  return {
    issueDateRules: issueDateRules,
    supplierRules: supplierRules,
    currencyRules: currencyRules,
    shopRules: shopRules,
    statusRules: statusRules,
    cashAmountRules: apCashAmountRules,
    fromDateRules: fromDateRules,
    toDateRules: toDateRules,
    remarkRules: remarkRules,
    codeRules: codeRules,
    nameRules: nameRules,
    unitRules: unitRules,
    qtyRules: qtyRules,
    percentageRules: percentageRules,
    sellingPriceRules: apSellingPriceRules,
    exchangeRateMMKRules: exchangeRateMMKRules,
    invoiceNoRules: invoiceNoRules,
    poNoRules: poNoRules,
    required: required,
  };
}

export function ShopTypeFormRules() {
  return {
    shopTypeNameRules: nameRules,
    codeRules: codeRules,
    descriptionRules: descriptionRules,
  };
}

export function CountryFormRules() {
  return {
    lengthRequiredRules: lengthRequiredRules,
    lengthRules: lengthRules,
  };
}

/* Validation Rules For Unit Form */
export function UnitFormRules() {
  return {
    unitNameRules: nameRules,
    codeRules: codeRules,
    descriptionRules: descriptionRules,
  };
}

/* Validation Rules For Product Group Form */
export function ProductGroupFormRules() {
  return {
    productGroupNameRules: nameRules,
    codeRules: codeRules,
    descriptionRules: descriptionRules,
  };
}

/* Validation Rules For Product Form */
export function ProductFormRules() {
  return {
    productNameRules: nameRules,
    productName2Rules: name2Rules,
    codeRules: codeRules,
    descriptionRules: descriptionRules,
    brandRules: brandRules,
    categoryRules: categoryRules,
    barcodeRules: barcodeRules,
    factorRules: factorRules,
    unitRules: unitRules,
    unitCostRules: unitCostRules,
    sellingPriceRules: sellingPriceRules,
    unitCostPercentageRules: unitCostPercentageRules,
    sellingPricePercentageRules: sellingPricePercentageRules,
    geraterThanZeroQtyRules: geraterThanZeroQtyRules,
  };
}

export function WarehouseFormRules() {
  return {
    warehouseNameRules: shopNameRules,
    codeRules: codeRules,
    locationRules: locationRules,
    descriptionRules: descriptionRules,
    returnWarehouseRules: returnWarehouseRules,
    nameRules: nameRules,
    selfExpireRules: selfExpireRules,
    capacityRules: capacityRules,
    bintypeRules: bintypeRules,
    warehouseRules: warehouseRules,
    stockBalanceRules: stockBalanceRules,
  };
}

export function StockTransferFormRules() {
  return {
    issueDateRules: issueDateRules,
    descriptionRules: descriptionRules,
    fromWarehouseRules: fromWarehouseRules,
    toWarehouseRules: toWarehouseRules,
    productNameRules: productNameRules,
    unitRules: unitRules,
    statusRules: statusRules,
    transferQtyRules: transferQtyRules,
    codeRules: codeRules,
    serialNoRules: lengthRules,
  };
}

export function StockInFormRules() {
  return {
    warehouseRules: warehouseRules,
    poNoRules: poNoRules,
    issueDateRules: issueDateRules,
    descriptionRules: descriptionRules,
    productNameRules: nameRules,
    unitCostRules: unitCostRules,
    sellingPriceRules: sellingPriceRules,
    geraterThanZeroQtyRules: geraterThanZeroQtyRules,
    unitRules: unitRules,
    remarkRules: descriptionRules,
    typeRules: typeRules,
    statusRules: statusRules,
    codeRules: codeRules,
    serialNoRules: lengthRules,
  };
}

export function EMRFormRules() {
  return {
    required: required,
    serialNoRules: serialNoRules,
    reasonRules: reasonRules,
    codeRules: codeRules,
    nameRules: nameRules,
    geraterThanZeroQtyRules: geraterThanZeroQtyRules,
    unitCostRules: unitCostRules,
    jobNoRules: jobNoRules,
    remarkRules: remarkRules,
  };
}

export function StoreReturnNoteFormRules() {
  return {
    required: required,
    reasonRules: reasonRules,
    nameRules: nameRules,
    codeRules: codeRules,
    geraterThanZeroQtyRules: geraterThanZeroQtyRules,
    unitCostRules: unitCostRules,
    remarkRules: remarkRules,
    jobNoRules: jobNoRules,
  };
}

export function OrderFormRules() {
  return {
    csRequestDateRules: csRequestDateRules,
    shopRules: shopRules,
    customerIdRules: customerIdRules,
    addressRules: orderAddressRules,
    cityIdRules: cityIdRules,
    townshipIdRules: townshipIdRules,
    remarkRules: remarkRules,
    estDateRules: estDateRules,
    codeRules: codeRules,
    nameRules: nameRules,
    unitRules: unitRules,
    qtyRules: qtyRules,
    confirmQtyRules: confirmQtyRules,
    unitPriceRules: unitPriceRules,
    statusRules: statusRules,
    discountPercentRules: discountPercentRules,
    promotionPercentRules: promotionPercentRules,
    orderNoRules: lengthRequiredRules,
  };
}

export function StockAdjustmentFormRules() {
  return {
    issueDateRules: issueDateRules,
    descriptionRules: descriptionRules,
    warehouseRules: warehouseRules,
    statusRules: statusRules,
    codeRules: codeRules,
    binRules: binRules,
    qtyRules: qtyRules,
    serialNoRules: lengthRules,
  };
}

export function SaleFormRules() {
  return {
    qtyRules: qtyRules,
    customerIdRules: customerIdRules,
    remarkRules: remarkRules,
    discountAmountRules: discountAmountRules,
    receiveAmountRules: receiveAmountRules,
    discountPercentRules: discountPercentRules,
    promotionAmountRules: promotionAmountRules,
    promotionPercentRules: promotionPercentRules,
    binRules: binRules,
  };
}

export function WholeSaleFormRules() {
  return {
    qtyRules: qtyRules,
    sellingPriceRules: sellingPriceRules,
    customerIdRules: customerIdRules,
    issueDateRules: issueDateRules,
    deliveryInfoRules: deliveryInfoRules,
    remarkRules: remarkRules,
    discountAmountRules: discountAmountRules,
    depositeAmountRules: depositeAmountRules,
    discountPercentRules: discountPercentRules,
    promotionAmountRules: promotionAmountRules,
    promotionPercentRules: promotionPercentRules,
    unitPriceRules: unitPriceRules,
    binRules: binRules,
    required: required,
  };
}

export function CreditLevelFormRules() {
  return {
    creditLevelNameRules: nameRules,
    periodDaysRules: periodDaysRules,
    descriptionRules: descriptionRules,
  };
}

export function PurchaseOrderFormRules() {
  return {
    issueDateRules: issueDateRules,
    supplierRules: supplierRules,
    currencyRules: currencyRules,
    warehouseRules: warehouseRules,
    statusRules: statusRules,
    purchaseTypeRules: purchaseTypeRules,
    descriptionRules: descriptionRules,
    codeRules: codeRules,
    nameRules: nameRules,
    unitRules: unitRules,
    qtyRules: qtyRules,
    unitCostRules: poUnitCostRules,
    unitCostPercentageRules: unitCostPercentageRules,
    sellingPriceRules: sellingPriceRules,
    remarkRules: descriptionRules,
    unitCostMMKRules: unitCostMMKRules,
    purchasedExchangeRateMMKRules: purchasedExchangeRateMMKRules,
    tenderQtyRules: decQtyRules,
    exchangeRateRules: exchangeRateRules,
    lengthRules: lengthRules,
  };
}
export function ProcurementPlanFormRules() {
  return {
    issueDateRules: issueDateRules,
    supplierRules: supplierRules,
    currencyRules: currencyRules,
    warehouseRules: warehouseRules,
    statusRules: statusRules,
    purchaseTypeRules: purchaseTypeRules,
    descriptionRules: descriptionRules,
    codeRules: codeRules,
    nameRules: nameRules,
    unitRules: unitRules,
    qtyRules: qtyRules,
    unitCostRules: poUnitCostRules,
    unitCostPercentageRules: unitCostPercentageRules,
    sellingPriceRules: sellingPriceRules,
    remarkRules: remarkRules,
    unitCostMMKRules: unitCostMMKRules,
    purchasedExchangeRateMMKRules: purchasedExchangeRateMMKRules,
    tenderQtyRules: decQtyRules,
    lengthRules: lengthRules,
  };
}

export function orderPOFormRules() {
  return {
    issueDateRules: issueDateRules,
    warehouseRules: warehouseRules,
    currencyRules: currencyRules,
    statusRules: statusRules,
    descriptionRules: descriptionRules,
    orderRules: orderRules,
    qtyRules: qtyRules,
    supplierRules: supplierRules,
  };
}

export function CustomerFormRules() {
  return {
    nameRules: nameRules,
    customerCodeRules: customerCodeRules,
    codeRules: codeRules,
    addressRules: addressRules,
    phoneNoRules: phoneNoRules,
    emailRules: emailRules,
    creditLevelRules: creditLevelRules,
    cityIdRules: cityIdRules,
    townshipIdRules: townshipIdRules,
    levelRules: levelRules,
    levelNameRules: nameRules,
    percentageRules: percentageRules,
  };
}

export function SupplierFormRules() {
  return {
    companyNameRules: nameRules,
    addressRules: addressRules,
    phoneRules: phoneNoRules,
    emailRules: emailRules,
    contactPersonRules: nameRules,
    codeRules: codeRules,
    supplierTypeRules: supplierTypeRules,
    warehouseRules: warehouseRules,
    unitRules: unitRules,
    unitCostRules: unitCostRules,
    currencyRules: currencyRules,
    creditLevelRules: creditLevelRules,
  };
}

export function PriceModelRules() {
  return {
    priceModelRules: nameRules,
    descriptionRules: descriptionRules,
    productNameRules: nameRules,
    unitRules: unitRules,
    sellingPriceRules: sellingPriceRules,
    sellingPricePercentageRules: sellingPricePercentageRules,
    codeRules: codeRules,
  };
}

export function RegionRules() {
  return {
    nameRules: nameRules,
    descriptionRules: descriptionRules,
    productNameRules: nameRules,
    unitRules: unitRules,
    unitCostRules: unitCostRules,
    sellingPriceRules: sellingPriceRules,
    unitCostPercentageRules: unitCostPercentageRules,
    sellingPricePercentageRules: sellingPricePercentageRules,
    codeRules: codeRules,
    currencyRules: currencyRules,
  };
}

export function SaleReturnFormRules() {
  return {
    invoiceNoRules: invoiceNoRules,
    qtyRules: returnQtyRules,
  };
}

export function CreditCashFlowFormRules() {
  return {
    payAmountRules: payAmountRules,
    descriptionRules: descriptionRules,
  };
}

export function StockIssueFormRules() {
  return {
    reasonRules: descriptionRules,
    nameRules: nameRules,
    unitRules: unitRules,
    codeRules: codeRules,
    qtyRules: qtyRules,
    binRules: binRules,
    warehouseRules: warehouseRules,
    serialNoRules: lengthRules,
  };
}

export function CityFormRules() {
  return {
    nameRules: nameRules,
    descriptionRules: descriptionRules,
  };
}

export function ShopFormRules() {
  return {
    nameRules: shopNameRules,
    descriptionRules: descriptionRules,
    codeRules: codeRules,
    warehouseRules: warehouseRules,
    phoneNoRules: phoneNoRules,
    addressRules: addressRules,
    cityRules: cityRules,
    townShipRules: townShipRules,
    binListRules: binListRules,
  };
}
export function LetterHeadFromRules() {
  return {
    nameRules: ShopNameRulesLetter,
    typeRules: coatypeRules,
  }
}
export function CustomerShopFormRules() {
  return {
    nameRules: nameRules,
    customerShopTypeRules: customerShopTypeRules,
    codeRules: codeRules,
    customerShopCodeRules: customerShopCodeRules,
    latitudeRules: latitudeRules,
    longitudeRules: longitudeRules,
    customerIdRules: customerIdRules,
    cityIdRules: cityIdRules,
    townshipIdRules: townshipIdRules,
    shopTypeIdRules: shopTypeIdRules,
    descriptionRules: descriptionRules,
  };
}

export function WayAssignFormRules() {
  return {
    wayAssignDateRules: wayAssignDateRules,
    completeDateRules: completeDateRules,
    wayRules: wayRules,
    marketerRules: marketerRules,
    descriptionRules: descriptionRules,
  };
}

export function WayFormRules() {
  return {
    nameRules: nameRules,
    descriptionRules: descriptionRules,
  };
}

export function categoryGroupFormRules() {
  return {
    nameRules: nameRules,
    codeRules: codeRules,
    descriptionRules: descriptionRules,
  };
}

export function StockTemplateFormRules() {
  return {
    nameRules: nameRules,
    descriptionRules: descriptionRules,
    statusRules: statusRules,
    qtyRules: stockInQtyRules,
    unitRules: unitRules,
    codeRules: codeRules,
  };
}

export function BinTypeFormRules() {
  return {
    nameRules: nameRules,
    descriptionRules: descriptionRules,
    codeRules: codeRules,
  };
}

export function AccountHeadFormRules() {
  return {
    nameRules: nameRules,
    prefixNoRules: prefixNoRules,
    statusRules: statusRules,
  };
}

export function AccountTypeFormRules() {
  return {
    nameRules: nameRules,
    statusRules: statusRules,
    accountTypeCodeRules: accountTypeCodeRules,
    accountTypeNatureRules: accountTypeNatureRules,
  };
}

export function ChartOfAccountFormRules() {
  return {
    nameRules: nameRules,
    accountCodeRules: accountCodeRules,
    accountHeadRules: accountHeadRules,
    coatypeRules: coatypeRules,
    coanatureRules: coanatureRules,
    openingBalanceRules: openingBalanceRules,
    statusRules: statusRules,
  };
}

export function AssetFormRules() {
  return {
    required: required,
    depreciationCostRules: depreciationCostRules,
    recoveryPeriodRules: recoveryPeriodRules,
    geraterThanzeroPercentageRules: geraterThanzeroPercentageRules,
    zeroAmountRules: zeroAmountRules,
    lengthRules: lengthRules,
    geraterThanZeroQtyRules: geraterThanZeroQtyRules,
    integerRules: integerRules,
    decimalRules: decimalRules,
  };
}

export function BinFormRules() {
  return {
    nameRules: nameRules,
    selfExpireRules: selfExpireRules,
    capacityRules: capacityRules,
    bintypeRules: bintypeRules,
    warehouseRules: warehouseRules,
    stockBalanceRules: stockBalanceRules,
  };
}

export function BranchFormRules() {
  return {
    nameRules: nameRules,
    codeRules: codeRules,
    descriptionRules: lengthRules,
    addressRules: lengthRules,
  };
}

export function MaterialSessionFormRules() {
  return {
    nameRules: nameRules,
    codeRules: codeRules,
    descriptionRules: descriptionRules,
  };
}

export function CounterFormRules() {
  return {
    nameRules: nameRules,
    descriptionRules: descriptionRules,
    codeRules: codeRules,
    shopRules: shopRules,
  };
}

export function StockTransferRequestFormRules() {
  return {
    issueDateRules: issueDateRules,
    descriptionRules: descriptionRules,
    fromWarehouseRules: fromWarehouseRules,
    toWarehouseRules: toWarehouseRules,
    productNameRules: productNameRules,
    unitRules: unitRules,
    statusRules: statusRules,
    qtyRules: qtyRules,
    codeRules: codeRules,
  };
}

export function LocationMovementFormRules() {
  return {
    issueDateRules: issueDateRules,
    descriptionRules: descriptionRules,
    fromWarehouseRules: fromWarehouseRules,
    toWarehouseRules: toWarehouseRules,
    fromBinRules: fromBinRules,
    toBinRules: toBinRules,
    productNameRules: productNameRules,
    unitRules: unitRules,
    statusRules: statusRules,
    qtyRules: qtyRules,
    codeRules: codeRules,
    serialNoRules: lengthRules,
  };
}

export function DamageFormRules() {
  return {
    issueDateRules: issueDateRules,
    shopRules: shopRules,
    customerIdRules: customerIdRules,
    statusRules: statusRules,
    invoiceTypeRules: invoiceTypeRules,
    remarkRules: damageRemarkRules,
    codeRules: codeRules,
    nameRules: nameRules,
    unitRules: unitRules,
    qtyRules: qtyRules,
    sellingPriceRules: sellingPriceRules,
    discountPercentRules: discountPercentRules,
    warehouseRules: warehouseRules,
    binRules: binRules,
    creditNoteNoRules: lengthRules,
    promotionAmountRules: promotionAmountRules,
    discountAmountRules: discountAmountRules,
    damageExpenseAmountRules: damageExpenseAmountRules,
    taxAmountRules: taxAmountRules,
  };
}

export function GeneralLedgerFormRules() {
  return {
    codeRules: codeRules,
    operationSettingRules: operationSettingRules,
    nameRules: nameRules,
    debitCodeRule: debitCodeRule,
    creditCodeRule: creditCodeRule,
    creditCodeNameRule: creditCodeNameRule,
    debitCodeNameRule: debitCodeNameRule,
    invoiceNoRule: invoiceNoRule,
    chequeNoRule: chequeNoRule,
    amountRule: amountRule,
  };
}

export function OperationSettingFormRules() {
  return {
    nameRules: nameRules,
    descriptionRules: descriptionRules,
    statusRules: statusRules,
    operationTypeRules: operationTypeRules,
    debitCodeRule: debitCodeRule,
    creditCodeRule: creditCodeRule,
  };
}

export function LayoutSettingFormRules() {
  return {
    nameRules: nameRules,
    descriptionRules: descriptionRules,
    statusRules: statusRules,
    layoutTypeRules: layoutTypeRules,
    sessionRules: sessionRules,
  };
}

export function FinanceSessionFormRules() {
  return {
    shopRules: shopRules,
    financeSettingRules: financeSettingRules,
  };
}

export function FinanceSettingFormRules() {
  return {
    codeRules: codeRules,
    financialYearRules: financialYearRules,
    startMonthRules: startMonthRules,
    endMonthRules: endMonthRules,
  };
}

export function StockTakeFormRules() {
  return {
    warehouseRules: warehouseRules,
  };
}

export function SaleTeamFormRules() {
  return {
    codeRules: codeRules,
    nameRules: nameRules,
    descriptionRules: descriptionRules,
  };
}

export function ProductionItemFormRules() {
  return {
    codeRules: codeRules,
    nameRules: nameRules,
    descriptionRules: descriptionRules,
    remarkRules: remarkRules,
    geraterThanzeroPercentageRules: geraterThanzeroPercentageRules,
  };
}

export function ProductionPlanFormRules() {
  return {
    required: required,
    descriptionRules: descriptionRules,
    codeRules: codeRules,
    nameRules: nameRules,
    unitRules: unitRules,
    remarkRules: remarkRules,
    zeroQtyRules: zeroQtyRules,
    //pendingZeroQtyRules: pendingZeroQtyRules,
  };
}

export function ProductionCostingFormRules() {
  return {
    required: required,
    zeroUnitCostRules: zeroUnitCostRules,
    lengthRequiredRules: lengthRequiredRules,
  };
}

export function ProductionOrderFormRules() {
  return {
    required: required,
    unitRules: unitRules,
    zeroQtyRules: zeroQtyRules,
    geraterThanZeroQtyRules: geraterThanZeroQtyRules,
  };
}

export function QCFormRules() {
  return {
    issueDateRules: issueDateRules,
    qcNoRules: qcNoRules,
    warehouseRules: warehouseRules,
    poNoRules: poNoRules,
    productNameRules: productNameRules,
    unitRules: unitRules,
    qtyRules: qtyRules,
    supplierRules: supplierRules,
  };
}

export function DepartmentFormRules() {
  return {
    departmentNameRules: nameRules,
    codeRules: codeRules,
    descriptionRules: descriptionRules,
  };
}

export function ManufacturingCostFormRules() {
  return {
    nameRules: nameRules,
    codeRules: codeRules,
  };
}

export function ProductionFormRules() {
  return {
    required: required,
    lengthRequiredRules: lengthRequiredRules,
    lengthRules: lengthRules,
    geraterThanzeroPercentageRules: geraterThanzeroPercentageRules,
    zeroUnitCostRules: zeroUnitCostRules,
    zeroQtyRules: zeroQtyRules,
    zeroUsageQtyRules: zeroUsageQtyRules,
    geraterThanZeroQtyRules: geraterThanZeroQtyRules,
  };
}

export function MaintenanceFrequencyFormRules() {
  return {
    nameRules: nameRules,
    serialNoRules: requiredSerialNoRules,
    descriptionRules: descriptionRules,
  };
}

export function MaintenanceTypeFormRules() {
  return {
    nameRules: nameRules,
    codeRules: codeRules,
    descriptionRules: descriptionRules,
  };
}

export function MachineTypeFormRules() {
  return {
    nameRules: nameRules,
    codeRules: codeRules,
    descriptionRules: descriptionRules,
  };
}

export function CheckListFrequencyFormRules() {
  return {
    nameRules: nameRules,
    serialNoRules: requiredSerialNoRules,
    descriptionRules: descriptionRules,
  };
}

export function MachineFormRules() {
  return {
    required: required,
    qtyRules: qtyRules,
    lengthRules: lengthRules,
    lengthRequiredRules: lengthRequiredRules,
    zeroAmountRules: zeroAmountRules,
  };
}

export function BudgetFormRules() {
  return {
    required: required,
    lengthRules: lengthRules,
    lengthRequiredRules: lengthRequiredRules,
    greaterZeroAmountRules: greaterZeroAmountRules,
  };
}

/* Validation Rules */
let financialYearRules = [(v) => !!v || "Financial Year Name is required"];
let startMonthRules = [(v) => !!v || "Start Month is required"];
let endMonthRules = [(v) => !!v || "End Month is required"];
let financeSettingRules = [(v) => !!v || "Please Select Finance Setting"];

let usernameRules = [(v) => !!v || "Username is required"];

let passwordRules = [
  (v) => !!v || "Password is required",
  (v) =>
    (v && v.length > 6) || "Password length must be greater than 6 characters",
];

let descriptionRules = [
  (v) => v.length <= 500 || "Description must be less than 500 characters",
];

let lengthRules = function (length, fieldName) {
  return [
    (v) => v.length <= length || fieldName + " must not be greater than " + length + " characters",
  ];
};

let lengthRequiredRules = function (length, fieldName) {
  return [
    (v) => !!v || fieldName + " is required",
    (v) => (v && v.length <= length) || fieldName + " must not be greater than " + length + " characters",
  ];
};

let reasonRules = [
  (v) => v.length <= 500 || "Reason must be less than 500 characters",
];

let jobNoRules = [
  (v) => v.length <= 500 || "Job No must be less than 500 characters",
];

let serialNoRules = [
  (v) => v.length <= 255 || "Serial No must be less than 255 characters",
];

let requiredSerialNoRules = [
  (v) => !!v || "Serial no is required",
  (v) => v.length <= 20 || "Serial no must not be greater than 20 characters.",
]

let remarkRules = [
  (v) => v.length <= 500 || "Remark must be less than 500 characters",
];

let damageRemarkRules = [
  (v) => v.length <= 2000 || "Remark must be less than 2000 characters",
];

let shopNameRules = [
  (v) => !!v || "Name is required",
  (v) => (v && v.length <= 1000) || "Name must be less than 1000 characters",
];

let nameRules = [
  (v) => !!v || "Name is required",
  (v) => (v && v.length <= 100) || "Name must be less than 100 characters",
];

let name2Rules = [
  (v) => !!v || v.length <= 100 || "Name must be less than 100 characters",
];

let customerCodeRules = [
  (v) => v.length <= 20 || "Code must be less than 20 characters",
];

let customerShopCodeRules = [
  (v) => v.length <= 20 || "Code must be less than 20 characters",
];

let codeRules = [
  (v) => !!v || "Code is required",
  (v) => (v && v.length <= 20) || "Code must be less than 20 characters",
  (v) => {
    const pattern = /^\s*\S.*$/;
    return pattern.test(v) || "Code is required";
  },
];

let accountCodeRules = [
  (v) => !!v || "Code is required",
  (v) => (v && v < 100000000) || "Code must not be greater than 99999999",
  (v) => {
    const pattern = /^[0-9]+$/;
    return pattern.test(v) || "Invalid Code.";
  },
];

let accountTypeCodeRules = [
  (v) => !!v || "Code is required",
  (v) => (v && v.length == 3) || "Code must be 3 characters",
  (v) => {
    const pattern = /[a-zA-Z0-9]{3}/;
    return pattern.test(v) || "Invalid Code.";
  },
];

let locationRules = [
  (v) => !!v || "Location is required",
  (v) => (v && v.length <= 100) || "Location must be less than 100 characters",
];

let brandRules = [(v) => !!v || "Please select the brand"];

let coatypeRules = [(v) => !!v || "Please select the type"];

let accountTypeNatureRules = [(v) => !!v || "Please select the nature"];

let accountHeadRules = [(v) => !!v || "Please select the Account Head"];

let coanatureRules = [(v) => !!v || "Please select the nature"];

let categoryRules = [(v) => !!v || "Please select the category"];

let ShopNameRulesLetter = [(v) => !!v || "Please select the Shop"];

let barcodeRules = [
  (v) => !!v || "Barcode is required",
  (v) =>
    (v && v.length <= 100) || "Barcode length must be less than 100 characters",
  (v) => {
    const pattern = /^[A-Z0-9]+$/;
    return pattern.test(v) || "Invalid barcode.";
  },
];

let operationSettingRules = [(v) => !!v || "Please select operation setting"];

let factorRules = [
  (v) => !!v || "Factor is required",
  (v) => (v && v < 1000000) || "Factor must not be greater than 999999",
  (v) => {
    const pattern = /^[0-9]+$/;
    return pattern.test(v) || "Invalid factor.";
  },
];

let unitRules = [(v) => !!v || "Please select the unit"];

let unitCostRules = [
  (v) => !!v || "Unit cost is required",
  (v) =>
    (v && v < 10000000000) || "Unit cost must not be greater than 9999999999",
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid unit cost.";
  },
];

let zeroUnitCostRules = function (menuName) {
  return [
    (v) => {
      const pattern = /^\d+(\.\d{1,6})*$/;
      return pattern.test(v) || "Invalid " + menuName + ".";
    },
    (v) => (v >= 0) || menuName + " must be greater than or equal to 0.",
    (v) => (v >= 0 && v < 10000000000) || menuName + " length must not be greater than 9999999999",
  ];
};

let poUnitCostRules = [
  (v) => !!v || "Unit cost is required",
  (v) =>
    (v && v < 10000000000) || "Unit cost must not be greater than 9999999999",
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid unit cost.";
  },
];

let unitCostMMKRules = [
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid unit cost(MMK).";
  },
];

let exchangeRateMMKRules = [
  (v) => !!v || "Exchange Rate(MMK) is required",
  (v) => (v && v > 0) || "Exchange Rate(MMK) must be greater than 0",
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid exchange rate(MMK).";
  },
];

let purchasedExchangeRateMMKRules = [
  (v) => !!v || "Purchased Exchange Rate(MMK) is required",
  (v) => (v && v > 0) || "Purchased Exchange Rate(MMK) must be greater than 0",
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid Purchased Exchange Rate(MMK).";
  },
];

let unitCostPercentageRules = [
  (v) => (v > -1 && v < 101) || "percent must between 0 and 100",
];

let sellingPricePercentageRules = [
  (v) => (v > -1 && v < 101) || "percent must between 0 and 100",
];

let sellingPriceRules = [
  (v) => !!v || "Selling price is required",
  (v) =>
    (v && v < 10000000000) ||
    "Selling price must not be greater than 9999999999",
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid selling price.";
  },
];

let apSellingPriceRules = [
  (v) => !!v || "Selling price is required",
  (v) =>
    (v && v < 10000000000) ||
    "Selling price must not be greater than 9999999999",
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid selling price.";
  },
];

let amountRule = [
  (v) => !!v || "Amount is required",
  (v) =>
    (v && v < 1000000000000000) ||
    "Amount must not be greater than 999999999999999",
  (v) => {
    const pattern = /^-?\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid Amount.";
  },
];

let openingBalanceRules = [
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid opening balance.";
  },
];

let prefixNoRules = [
  (v) => !!v || "Prefix No is required",
  (v) => v.length < 4 || "Prefix No length must not be greater than 3.",
  (v) => {
    const pattern = /^[\w-_.]*$/;
    return pattern.test(v) || "Invalid Prefix.";
  },
];

let depreciationCostRules = [
  (v) => {
    const pattern = /^\d+(\.\d{1,2})*$/;
    return pattern.test(v) || "Invalid cost.";
  },
  (v) => (v > 0) || "Cost must be greater than 0.",
  (v) => (v > 0 && v < 1000000000000000) || "Cost must not be greater than 999999999999999",
];

let payAmountRules = [
  (v) => !!v || "Pay Amount is required",
  (v) => (v && v < 10000000) || "Pay Amount must not be greater than 9999999",
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid unit cost.";
  },
];

let zeroAmountRules = function (menuName) {
  return [
    (v) => {
      const pattern = /^\d+(\.\d{1,2})*$/;
      return pattern.test(v) || "Invalid " + menuName + ".";
    },
    (v) => (v >= 0) || menuName + " must be greater than or equal to 0.",
    (v) => (v >= 0 && v < 100000000000000) || menuName + " must not be greater than 99999999999999.",
  ];
};

let greaterZeroAmountRules = function (menuName) {
  return [
    (v) => {
      const pattern = /^\d+(\.\d{1,2})*$/;
      return pattern.test(v) || "Invalid " + menuName + ".";
    },
    (v) => (v > 0) || menuName + " must be greater than 0.",
    (v) => (v > 0 && v < 100000000000000) || menuName + " must not be greater than 99999999999999.",
  ];
};

let issueDateRules = [(v) => !!v || "Issue date is required."];

let orderRules = [(v) => !!v || "Please choose order no."];

let csRequestDateRules = [(v) => !!v || "Customer Request date is required."];

let estDateRules = [(v) => !!v || "Estimate Dellivery date is required."];

let wayAssignDateRules = [(v) => !!v || "WayAssign date is required."];

let completeDateRules = [(v) => !!v || "Complete date is required."];

let wayRules = [(v) => !!v || "Way is required."];

let marketerRules = [(v) => !!v || "Marketer is required."];

let fromWarehouseRules = [(v) => !!v || "From warehouse is required."];

let fromBinRules = [(v) => !!v || "From bin is required."];

let toBinRules = [(v) => !!v || "To bin is required."];

let supplierRules = [(v) => !!v || "Please choose the supplier."];

let currencyRules = [(v) => !!v || "Please choose the currency."];

let toWarehouseRules = [(v) => !!v || "To warehouse is required."];

let returnWarehouseRules = [(v) => !!v || "Return warehouse is required."];

let statusRules = [(v) => !!v || "Please choose the status."];

let purchaseTypeRules = [(v) => !!v || "Please choose the purchase type."];

let supplierTypeRules = [(v) => !!v || "Please choose the supplier type."];

let operationTypeRules = [(v) => !!v || "Please choose the Operation Type."];

let layoutTypeRules = [(v) => !!v || "Please choose the Layout Type."];

let sessionRules = [(v) => !!v || "Please choose the Session."];

let invoiceTypeRules = [(v) => !!v || "Please choose the invoice type."];

let productNameRules = [(v) => !!v || "Please choose the product name."];

let fromDateRules = [(v) => !!v || "From Date is required."];

let toDateRules = [(v) => !!v || "To Date is required."];

let returnQtyRules = [
  (v) => (v >= 0 && v < 10000000) || "Qty length must not be greater than 7",
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid qty.";
  },
];

let qtyRules = [
  (v) => !!v || "Qty is required",
  (v) => (v && v < 10000000) || "Qty length must not be greater than 7",
  (v) => (v && v > 0) || "Qty must be greater than 0.",
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid qty.";
  },
];

let geraterThanZeroQtyRules = function (menuName) {
  return [
    (v) => {
      const pattern = /^\d+(\.\d{1,6})*$/;
      return pattern.test(v) || "Invalid " + menuName + ".";
    },
    (v) => (v > 0) || menuName + " must be greater than 0.",
    (v) => (v > 0 && v < 10000000) || menuName + " length must not be greater than 7",
  ];
};

/*let pendingZeroQtyRules = function (menuName, oldQty) {
  return [
    (v) => !!v || menuName + " is required",
    (v) => (v && v < 10000000) || menuName + " length must not be greater than 7",
    (v) => (v && v > 0) || menuName + " must be greater than 0.",
    (v) => (v && v >= oldQty) || menuName + " must be greater than or equal to " + oldQty + ".",
    (v) => {
      const pattern = /^\d+(\.\d{1,6})*$/;
      return pattern.test(v) || "Invalid " + menuName + ".";
    },
  ];
};*/

let zeroQtyRules = function (menuName) {
  return [
    (v) => {
      const pattern = /^\d+(\.\d{1,6})*$/;
      return pattern.test(v) || "Invalid " + menuName + ".";
    },
    (v) => (v >= 0) || menuName + " must be greater than or equal to 0.",
    (v) => (v >= 0 && v < 10000000) || menuName + " length must not be greater than 7",
  ];
};

let exchangeRateRules = function (menuName) {
  return [
    (v) => {
      const pattern = /^\d+(\.\d{1,6})*$/;
      return pattern.test(v) || "Invalid " + menuName;
    },
    (v) => (v > 0) || menuName + " must be greater than 0",
  ];
};

let zeroUsageQtyRules = function (menuName, oldQty) {
  return [
    (v) => {
      const pattern = /^\d+(\.\d{1,6})*$/;
      return pattern.test(v) || "Invalid " + menuName + ".";
    },
    (v) => (v >= 0) || menuName + " must be greater than or equal to 0.",
    (v) => (v >= 0 && v >= oldQty) || menuName + " must not be less than " + oldQty + ".",
    (v) => (v >= 0 && v < 10000000) || menuName + " length must not be greater than 7",
  ];
};

let decQtyRules = [
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid qty.";
  },
];

let confirmQtyRules = [
  (v) => !v || (v && v < 10000000) || "Qty length must not be greater than 7",
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid qty.";
  },
];

let recoveryPeriodRules = [
  (v) => {
    const pattern = /^[0-9]+$/;
    return pattern.test(v) || "Invalid recovery period(month).";
  },
  /*(v) => !!v || "Period is required",*/
  (v) => (v > 0) || "Recovery period(month) must be greater than 0",
  (v) => (v > 0 && v < 1000) || "Recovery period(month) length must not be greater than 3",
];

let integerRules = function (menuName) {
  return [
  (v) => {
    const pattern = /^[0-9]+$/;
    return pattern.test(v) || "Invalid "+menuName+".";
  },
];
};

let transferQtyRules = [
  (v) => (v && v < 10000000) || "Qty length must not be greater than 7",
  (v) => (v && v > 0) || "Qty must be greater than 0.",
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid qty.";
  },
];

let levelRules = [
  (v) => !!v || "Level is required",
  (v) => {
    const pattern = /^[0-9]+$/;
    return pattern.test(v) || "Invalid qty.";
  },
];

let percentageRules = [
  (v) => !!v || "Percentage is required",
  (v) => (v && v >= 0 && v <= 100) || "Percentage must be between 0 and 100",
  (v) => {
    const pattern = /^\d{1,3}(\.\d{1,2})?$/;
    return pattern.test(v) || "Invalid percentage format. Use up to 2 decimal places.";
  },
];

let geraterThanzeroPercentageRules = function (menuName) {
  return [
    (v) => {
      const pattern = /^\d+(\.\d{1,2})*$/;
      return pattern.test(v) || "Invalid " + menuName + ".";
    },
    (v) => (v > 0) || menuName + " must be greater than zero.",
    (v) => (v > 0 && v <= 100) || menuName + " must not be greater than 100",
  ];
};

let decimalRules = function (menuName) {
  return [
    (v) => {
      const pattern = /^\d+(\.\d{1,2})*$/;
      return pattern.test(v) || "Invalid " + menuName + ".";
    },
  ];
};

let periodDaysRules = [
  (v) => !!v || "Period Days is required",
  (v) => (v && v < 100000) || "Period Days length must not be greater than 5.",
  (v) => {
    const pattern = /^[0-9]+$/;
    return pattern.test(v) || "Invalid Period Days.";
  },
];

let warehouseRules = [(v) => !!v || "Please select the warehouse"];

let binRules = [(v) => !!v || "Please select the bin"];

let binListRules = [(v) => (v && v.length > 0) || "Please select the bin"];

let shopRules = [(v) => !!v || "Please select the shop"];

let poNoRules = [
  (v) => !!v || "Po No is required.",
  (v) => (v && v.length <= 30) || "Po No must be less than 30 characters",
];

let addressRules = [
  (v) => v.length <= 500 || "Address must be less than 500 characters.",
];

let orderAddressRules = [
  (v) => !!v || "Please provide address.",
  (v) => v.length <= 500 || "Address must be less than 500 characters.",
];

let cityRules = [
  (v) => v.length <= 500 || "city name must be less than 500 characters.",
];

let townShipRules = [
  (v) => v.length <= 500 || "township name must be less than 500 characters.",
];

let phoneNoRules = [
  (v) => !!v || "PhoneNo is required.",
  (v) => v.length <= 50 || "PhoneNo must be less than 50 characters.",
];

let emailRules = [
  (v) => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(v) || "Invalid e-mail.";
  },
];

let debitCodeRule = [(v) => !!v || "Debit Code is required."];

let creditCodeRule = [(v) => !!v || "Credit Code is required."];

let debitCodeNameRule = [(v) => !!v || "Debit Code Name is required."];

let creditCodeNameRule = [(v) => !!v || "Credit Code Name is required."];

let invoiceNoRule = [(v) => !!v || "Invoice No is required."];

let chequeNoRule = [(v) => !!v || "Cheque No is required."];

let creditLevelRules = [(v) => !!v || "Please select credit level."];

let customerIdRules = [(v) => !!v || "Please select customer."];

let customerShopTypeRules = [(v) => !!v || "Please select customer shop type."];

let cityIdRules = [(v) => !!v || "Please select city."];

let townshipIdRules = [(v) => !!v || "Please select township."];

let shopTypeIdRules = [(v) => !!v || "Please select shop type."];

let deliveryInfoRules = [(v) => !!v || "Delivery Info is required"];

let invoiceNoRules = [(v) => !!v || "Invoice No. is required"];

let accountReceivableTypeRules = [
  (v) => !!v || "Account Receivable Type is required",
];

let stockInQtyRules = [
  (v) => v < 10000000 || "Qty length must not be greater than 7",
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid qty.";
  },
];

let latitudeRules = [
  (v) => {
    const pattern = /^[-+]?[0-9]{1,7}(\.[0-9]+)?$/;
    return pattern.test(v) || "Invalid Latitude.";
  },
];

let longitudeRules = [
  (v) => {
    const pattern = /^[-+]?[0-9]{1,7}(\.[0-9]+)?$/;
    return pattern.test(v) || "Invalid Longitude.";
  },
];

let selfExpireRules = [(v) => !!v || "selfExpire date is required."];

let capacityRules = [
  (v) => v < 10000000 || "length must not be greater than 7",
  (v) => {
    const pattern = /^[0-9]+$/;
    return pattern.test(v) || "Invalid capacity";
  },
];

let bintypeRules = [(v) => !!v || "Please select the bintype"];

let typeRules = [(v) => !!v || "Please select the type"];

let stockBalanceRules = [
  (v) => v < 10000000 || "length must not be greater than 7",
  (v) => {
    const pattern = /^[0-9]+$/;
    return pattern.test(v) || "Invalid stock balance";
  },
];

let cashAmountRules = [
  (v) => !!v || "Cash Amount is required",
  (v) => v > 0 || "Cash Amount must be greater than zero",
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid Cash Amount";
  },
];

let apCashAmountRules = [
  (v) => !!v || "Cash Amount is required",
  (v) => v > 0 || "Cash Amount must be greater than zero",
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid Cash Amount";
  },
];

let discountAmountRules = [
  (v) => v < 10000000 || "Discount Amount must not be greater than 9999999",
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid discount amount.";
  },
];

let discountPercentRules = [
  (v) => v <= 100 || "Discount(%) must not be greater than 100.",
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid (%).";
  },
];

let receiveAmountRules = [
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid received amount.";
  },
];

let depositeAmountRules = function (netAmount) {
  return [
    (v) =>
      v <= parseFloat(netAmount) ||
      "Deposit must not be greater than Net Amount",
    (v) => {
      const pattern = /^\d+(\.\d{1,6})*$/;
      return pattern.test(v) || "Invalid deposite amount.";
    },
  ];
};

let required = function (errorMessage) {
  return [
    (v) => !!v || errorMessage + " is required."
  ];
};

/*let requiredListRules = function (errorMessage) {
  return [
    (v) => (v && v.length > 0) || "Please select the " + errorMessage,
  ];
};*/

let promotionAmountRules = [
  (v) => v < 10000000 || "Promotion Amount must not be greater than 9999999",
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid promotion amount.";
  },
];

let promotionPercentRules = [
  (v) => v <= 100 || "Promotion(%) must not be greater than 100.",
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid (%).";
  },
];

let damageExpenseAmountRules = [
  v => (v < 10000000) || "Expense Amount must not be greater than 9999999",
  v => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid Expense Amount.";
  }
];

let taxAmountRules = [
  v => (v < 10000000) || "Tax Amount must not be greater than 9999999",
  v => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid tax amount.";
  }
];

let unitPriceRules = [
  (v) => v > 0 || "Selling Price must be greater than zero.",
  (v) => {
    const pattern = /^\d+(\.\d{1,6})*$/;
    return pattern.test(v) || "Invalid Price.";
  },
];

let qcNoRules = [(v) => !!v || "QC No is required."];
